import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { DtoClientsGetReq } from "./abst/DtoClientsGetReq";
import { DtoApiPager } from "./abst/DtoApiPager";

export class DtoClientsGetReqImple extends DtoClientsGetReq {
  //売上先マスタ一覧の検索条件
  public clientId_start: number | null = null;
  public clientId_end: number | null = null;
  public clientName: string | null = null;
  public keyword: string | null = null;
  
  public pager = new DtoApiPager();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック
    if (chkPager) {
      this.pager.IsValid4Pager(res);
    } else {
      res = res.concat(super.IsValid());
    }

    return res;
  }
}
